export const getPublicContext = () => {
    const publicAppPath = process.env.REACT_APP_BASE_TRADE_URL.split('/').filter(s => s.length);
    return publicAppPath[publicAppPath.length - 1]
  }
  